<template>
  <FaIcon :icon="CREDENTIAL_DEFAULT_ICON" />
</template>

<script setup lang="ts">
import { CREDENTIAL_DEFAULT_ICON } from '@/constants/person';
</script>
